"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _DockMonitor = _interopRequireDefault(require("./DockMonitor"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _DockMonitor["default"];
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9pbmRleC50cyJdLCJuYW1lcyI6WyJEb2NrTW9uaXRvciJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOzs7O2VBQ2VBLHVCIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IERvY2tNb25pdG9yIGZyb20gJy4vRG9ja01vbml0b3InO1xuZXhwb3J0IGRlZmF1bHQgRG9ja01vbml0b3I7XG4iXX0=


//////////////////
// WEBPACK FOOTER
// ./~/redux-devtools-dock-monitor/lib/index.js
// module id = 1375
// module chunks = 0